<div [formGroup]="mainForm">
  <textarea matInput formControlName="textControlName"></textarea>
</div>